import { createFileRoute, Outlet } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  search: z.string().optional(),
  account_id: z.string().optional(),
  division_id: z.string().optional(),
  contact_type: z
    .enum(['reseller_rep', 'end_user_contact', 'distributor_rep'])
    .optional(),
  has_email: z.boolean().optional(),
  show_inactive: z.boolean().optional(),
  sort_by: z.string().optional().default('last_name'),
  sort_dir: z.enum(['asc', 'desc']).optional().default('asc'),
  view: z.string().optional(),
})

export const Route = createFileRoute('/_authed/contacts')({
  validateSearch: searchSchema,
  component: () => <Outlet />,
})
